import { cloneElement } from 'react';
import { Skeleton } from '../../../../feedback/Skeleton';
import { Flex } from '../../../../layout/Flex';
import { BusinessStatisticSectionFlex } from '../BusinessStatisticSection/styles';
import { StatSectionSkeletonProps } from './types';

const StatSectionSkeleton = (props: StatSectionSkeletonProps) => {
    const { statsSlot } = props;

    return (
        <BusinessStatisticSectionFlex width={{ xs: '100%', sm: '50%' }} p={2}>
            <Skeleton width="30%" variant="text" height={24} />
            <Flex width="100%" direction="row" flexWrap="wrap">
                {cloneElement(statsSlot)}
            </Flex>
        </BusinessStatisticSectionFlex>
    );
};

const StatItemSkeleton = () => (
    <Flex width="100%" spacing={0.5} pb={2}>
        <Skeleton width="80px" variant="text" height={26} />
        <Skeleton width="100%" variant="text" height={36} />
        <Skeleton width="100%" variant="text" height={16} />
        <Skeleton width="100%" variant="text" height={16} />
    </Flex>
);

export const BusinessStatisticSkeleton = () => (
    <Flex width="100%" flexWrap="wrap" direction="row" alignItems="stretch">
        <StatSectionSkeleton statsSlot={<StatItemSkeleton />} />
        <StatSectionSkeleton statsSlot={<StatItemSkeleton />} />
        <StatSectionSkeleton statsSlot={<StatItemSkeleton />} />
        <StatSectionSkeleton statsSlot={<StatItemSkeleton />} />
        <StatSectionSkeleton statsSlot={<StatItemSkeleton />} />
    </Flex>
);
